import { render, staticRenderFns } from "./AssumptionsModal.vue?vue&type=template&id=5680c544&"
import script from "./AssumptionsModal.vue?vue&type=script&lang=js&"
export * from "./AssumptionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports